import { render } from "./Biodata.vue?vue&type=template&id=6735f5b0&scoped=true"
import script from "./Biodata.vue?vue&type=script&lang=js"
export * from "./Biodata.vue?vue&type=script&lang=js"

import "./Biodata.vue?vue&type=style&index=0&id=6735f5b0&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6735f5b0"]])

export default __exports__